export default {
    feedback: {
        update: 'The innovation field was successfully updated.',
        create: 'The innovation field <strong>"{title}"</strong> was successfully created.',
        delete: 'The innovation field was successfully deleted.'
    }
}
